import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import SearchIcon from "@atlaskit/icon/glyph/editor/search";
import { TextField, AsyncSelect } from "../../Styled/atlaskitComponents";

import SELECT_STYLE from "../../../elementor/Components/Macros/Shared/selectStyle";
import { searchPages } from "../../../../helpers/search-pages";
import { searchSpaces } from "../../../../helpers/search-spaces";
import { buildPageData } from "./buildData";
import {
  HeaderLabels,
  ListItemsContainer,
  ListSpace,
  ListTitle,
  SearchSelectContainer,
  ListItem,
} from "./styled/Components";

function Pages({ value, setValue }) {
  const [input, setInput] = useState("");
  const [pages, setPages] = useState([]);
  const [selectedSpaceKey, setSelectedSpaceKey] = useState(null);

  const [selection, setSelection] = useState("");

  const getPages = async () => {
    try {
      const CQLquery = selectedSpaceKey?.value
        ? [`space = "${selectedSpaceKey.value}"`]
        : [];
      const response = await searchPages(input, [], CQLquery);

      const builtPages = buildPageData(response?.results || []);
      setPages([...builtPages]);
    } catch (err) {
      setPages([]);
    }
  };

  const loadSpaces = async (searchTerm) => {
    try {
      const response = await searchSpaces(searchTerm);

      if (response?.length) {
        const options = response.map((space) => ({
          label: space.name,
          value: space.key,
        }));
        return [{ label: "All Spaces", value: null }, ...options];
      }
      return [];
    } catch (error) {
      return [];
    }
  };

  const getSpaceSelectValue = () => {
    if (!selectedSpaceKey) {
      return { label: "All Spaces", value: null };
    }
    return selectedSpaceKey;
  };

  useEffect(() => {
    getPages();
  }, [input, selectedSpaceKey]);

  useEffect(() => {
    if (value?.source && value?.source === "page") {
      setSelection(value.id || "");
    }
  }, [value]);

  return (
    <div>
      <SearchSelectContainer>
        <AsyncSelect
          defaultOptions
          cacheOptions
          loadOptions={loadSpaces}
          value={getSpaceSelectValue()}
          onChange={(v) => setSelectedSpaceKey(v)}
          isClearable={!!selectedSpaceKey}
          styles={SELECT_STYLE}
        />

        <TextField
          elemAfterInput={<SearchIcon size="large" />}
          name="search-pages"
          placeholder="Type to search"
          style={{ height: "36px" }}
          isCompact
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </SearchSelectContainer>

      <ListItem style={{ padding: "16px 0 5px 0" }}>
        <HeaderLabels>Page title</HeaderLabels>
        <HeaderLabels>Space</HeaderLabels>
      </ListItem>

      <ListItemsContainer>
        {pages.map(({ id, type, title, space, link }) => (
          <ListItem
            key={id}
            isClickable
            isSelected={selection === id}
            onClick={() => {
              setSelection(id);
              setValue({ id, link, title, type, source: "page" });
            }}
          >
            <ListTitle>{title}</ListTitle>
            <ListSpace>{space}</ListSpace>
          </ListItem>
        ))}
      </ListItemsContainer>
    </div>
  );
}

Pages.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  setValue: PropTypes.func.isRequired,
};

export default Pages;
